import { render, staticRenderFns } from "./GestionBagage.vue?vue&type=template&id=763134ac&scoped=true"
import script from "./GestionBagage.vue?vue&type=script&lang=js"
export * from "./GestionBagage.vue?vue&type=script&lang=js"
import style0 from "./GestionBagage.vue?vue&type=style&index=0&id=763134ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763134ac",
  null
  
)

export default component.exports